export default "__VITE_ASSET__580515aa__"